import type { HttpClient } from '~/shared/api'
import type { LoggerFactory } from '~/shared/interfaces'
import type { RequestRestService } from '../RequestRestService'
import { FeedbacksMainService } from '~/services/feedbacks/FeedbacksMainService'


export class FeedbacksService {
  readonly main: FeedbacksMainService

  constructor(requestRest: RequestRestService, http: HttpClient, createLogger: LoggerFactory) {
    this.main = new FeedbacksMainService(http, createLogger('FeedbacksMainService'))
  }
}
